module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Settings#3-a3cdb7449dd6e01047a797be25136c56.svg";